<template>
    <div>
        <a-row type="flex" justify="center" >
            <vxe-button size="mini" status="primary" @click="print()">
                打印
            </vxe-button>
        </a-row>

        <div ref="batchPrintArea">
            <div v-for="(item,indexs) in batchPrintData" :key="indexs" class="printClass" style="page-break-after: always;">
                <a-row type="flex" justify="center" style="margin-top: 10px">
                    <table border="1" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
                        <tr>
                            <th colspan="7" class="table-name">客户信息档案表</th>
                        </tr>
                        <tr>
                            <th rowspan="3" class="td3">车辆信息</th>
                            <td colspan="1" class="td1">品系</td>
                            <td colspan="2" class="td2">{{item.strainName}}</td>
                            <td colspan="1" class="td1">购车时间</td>
                            <td colspan="2" class="td2">{{item.e3sDeliveryDate}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">底盘号</td>
                            <td colspan="2" class="td2">{{item.batholithNo}}</td>
                            <td colspan="1" class="td1">车型代码</td>
                            <td colspan="2" class="td2">{{item.modelCode}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">所属经理部</td>
                            <td colspan="2" class="td2">{{item.regionName}}</td>
                            <td colspan="1" class="td1">经销商</td>
                            <td colspan="2" class="td2">{{item.dealerName}}</td>
                        </tr>
                        <tr>
                            <th rowspan="7" class="td3">客户信息</th>
                            <td colspan="1" class="td1">姓名</td>
                            <td colspan="2" class="td2">{{item.custName}}</td>
                            <td colspan="1" class="td1">性别</td>
                            <td colspan="2" class="td2">{{item.sexName}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">电话</td>
                            <td colspan="2" class="td2">{{item.mobile}}</td>
                            <td colspan="1" class="td1">民族</td>
                            <td colspan="2" class="td2">{{item.nationName}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">身份证</td>
                            <td colspan="2" class="td2">{{item.idCard}}</td>
                            <td colspan="1" class="td1">出生日期</td>
                            <td colspan="2" class="td2">{{item.birthday}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">行业</td>
                            <td colspan="2" class="td2">{{item.industryName}}</td>
                            <td colspan="1" class="td1">客户类型</td>
                            <td colspan="2" class="td2">{{item.custCategoryName}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">是否乘龙老友</td>
                            <td colspan="2" class="td2">{{item.isOldFriendName}}</td>
                            <td colspan="1" class="td1">职位</td>
                            <td colspan="2" class="td2"></td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">省份</td>
                            <td colspan="2" class="td2">{{item.provinceName}}</td>
                            <td colspan="1" class="td1">市</td>
                            <td colspan="2" class="td2">{{item.cityName}}</td>
                        </tr>
                        <tr>
                            <td colspan="1" class="td1">区</td>
                            <td colspan="2" class="td2">{{item.districtName}}</td>
                            <td colspan="1" class="td1">详细地址</td>
                            <td colspan="2" class="td2" style="text-align: left;padding-left:10px;">{{item.address}}</td>
                        </tr>
                    </table>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['batchPrintData'],
        data() {
            return {
                item:{}
            }
        },
        async mounted() {

        },
        methods: {
            print(){
                this.$print(this.$refs.batchPrintArea)
            }
        }
    }
</script>

<style scoped>
table {
    border-collapse: collapse;
    width: 710px; /* 设置表格的固定宽度 */
    table-layout: fixed; /* 确保宽度固定 */
}
.printClass{
    padding-top: 100px;
}
.table-name {
    height: 60px;
    width:  710px;
    vertical-align: middle;
    text-align: center;
    font-size: 24px;
    color: #333;
}
.td1{
    width: 60px;
    height: 60px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
.td2{
    height: 60px;
    width: 100px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
.td3{
    width: 80px;
    height: 60px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
</style>
